import React from 'react';

const VB_W = 208;
const VB_H = 128;

export type MarkdownToolbarIconProps = {
  size?: number;
  className?: string;
};

/** Markdown "M" logo (not in lucide-react). Scales like other toolbar icons via `size` (height). */
export const MarkdownToolbarIcon = ({ size = 14, className }: MarkdownToolbarIconProps) => {
  const height = size;
  const width = (size * VB_W) / VB_H;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={`0 0 ${VB_W} ${VB_H}`}
      className={className}
      aria-hidden
    >
      <path d="M30 98V30h20l20 25 20-25h20v68H90V59L70 84 50 59v39H30z" fill="currentColor" />
      <path d="M155 98l30-33h-20V30h-20v35h-20l30 33z" fill="currentColor" />
    </svg>
  );
};
